var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-game",class:_vm.currentGame,on:{"click":function($event){return _vm.$emit('setSwipe')}}},[_c('img',{attrs:{"src":_vm.imageLink,"alt":_vm.imageAlt}})])}
var staticRenderFns = []

export { render, staticRenderFns }